export const MULTICAST_STORAGE_NAME = 'device_multicast';

export enum SCAN_ACTION_TYPES {
  PAUSE = 'pause',
  RESUME = 'resume',
  STOP = 'stop',
}

export type ScanActionType = SCAN_ACTION_TYPES;

export enum ACTIVE_SCAN_STATUSES {
  RUNNING = 'running',
  PAUSED = 'paused',
  NOT_RUNNING = 'not_running',
  STOPPED = 'stopped',
}

export type ActiveScanStatus = ACTIVE_SCAN_STATUSES;
